import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Bundle the locale JSONs directly into the JS — synchronously available on
// first render, so no "flash of fallback text" while an HTTP fetch resolves.
// CRA forbids imports from outside src/, so we keep the source-of-truth here.
// public/locales/ is no longer used at runtime; safe to delete later.
import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

export const supportedLngs = ['fr', 'en', 'ar'];
export const rtlLngs = ['ar'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs,
    ns: ['common'],
    defaultNS: 'common',
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    resources: {
      fr: { common: fr },
      en: { common: en },
      ar: { common: ar },
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'tafwija_lang',
      caches: ['localStorage'],
    },
    react: {
      // Translations are bundled so they're ready synchronously — no Suspense needed.
      useSuspense: false,
    },
  });

// Apply <html lang> + <html dir> on language change.
function applyDocumentDirection(lng) {
  const lang = lng?.split('-')[0] || 'fr';
  document.documentElement.lang = lang;
  document.documentElement.dir = rtlLngs.includes(lang) ? 'rtl' : 'ltr';
}

i18n.on('languageChanged', applyDocumentDirection);
if (i18n.isInitialized) applyDocumentDirection(i18n.language);
else i18n.on('initialized', () => applyDocumentDirection(i18n.language));

export default i18n;
